import { Fragment } from 'react';
import {
  type InvoiceRow,
  type ProjectRow,
} from '../../../shared/types';
import { formatMoney } from '../../lib/moneyFormat';
import { formatInvoiceNumber } from '../../../shared/format';
import {
  type SummaryPart,
} from '../../lib/projectDetailSummaries';
/** The middot-separated summary of a collapsed group, with its one tinted
    clause (gold money, red overdue, accent status). */
function SummaryLine({ parts }: { parts: SummaryPart[] }) {
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && ' · '}
          <span className={part.tone === 'gold' ? 'g' : part.tone === 'danger' ? 'd' : undefined}>
            {part.text}
          </span>
          {part.emphasis !== undefined && (
            <>
              {' '}
              <span className="a">{part.emphasis}</span>
            </>
          )}
        </Fragment>
      ))}
    </>
  );
}

/** The money value of a field as the sheet wants it — "3775", not "$3,775". */
function centsDraft(cents: number | null | undefined): string {
  return cents === null || cents === undefined ? '' : (cents / 100).toString();
}

/** "#0244 · $1,887" — the invoice the delivery page waits on. */
function gateLabel(gatingInvoiceId: string | null, invoices: InvoiceRow[]): string {
  if (!gatingInvoiceId) return '';
  const invoice = invoices.find((i) => i.id === gatingInvoiceId);
  if (!invoice) return 'No gate';
  return `${formatInvoiceNumber(invoice.invoice_number)} · ${formatMoney(invoice.amount_cents)}`;
}

/** The testimonial ask's current state, as the rail spells it. */
function testimonialSub(project: ProjectRow): string {
  if (project.testimonial_closed_at) {
    return project.testimonial_closed_reason === 'responded' ? project.testimonial_video_key ? 'Video received' : 'Responded' : 'Not asking';
  }
  if (project.testimonial_reminder_at) return 'Ask sent · reminder sent';
  if (project.testimonial_requested_at) return 'Ask sent';
  return 'Ask scheduled after delivery';
}

export { SummaryLine, centsDraft, gateLabel, testimonialSub };
